






import { Component, Vue, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { RenderMenuMixin } from '@/mixins';
import { AcgnStaticsMenu, AcgnStatisticDetailNor } from '@/components';

@Component({
  components: {
    AcgnStaticsMenu,
    AcgnStatisticDetailNor
  },
  mixins: [RenderMenuMixin]
})

/**
 * 总览-明细
 */
export default class StatisticStaffDetail extends Vue {

  // 渲染左侧菜单
  private renderMenu() {
    return (
      <acgn-statics-menu type="index" isNor={true}></acgn-statics-menu>
    );
  }
}
